import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { DeploymentsSection } from "@/features/omnimizer/components/DeploymentsSection";
import { ObservabilityPage } from "@/features/omnimizer/components/ObservabilityPage";

type ObservabilitySearch = { deployment?: string };

const ObservabilityRoute = () => {
  const { t } = useTranslation();
  const { deployment } = Route.useSearch();
  const navigate = useNavigate({ from: "/deployments/observability" });
  return (
    <DeploymentsSection section="observability" description={t("omnimizer.observability.description")}>
      <ObservabilityPage
        selectedId={deployment}
        onSelect={(id) => void navigate({ search: { deployment: id }, replace: true })}
      />
    </DeploymentsSection>
  );
};

export const Route = createFileRoute("/deployments/observability")({
  validateSearch: (search: Record<string, unknown>): ObservabilitySearch => ({
    deployment: typeof search.deployment === "string" ? search.deployment : undefined,
  }),
  component: ObservabilityRoute,
});
